/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sheet_Actions_DescInputs */

const es_nav_sheet_actions_desc = /** @type {(inputs: Nav_Sheet_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear cuenta, añadir barco o registro de patrón`)
};

const gl_nav_sheet_actions_desc = /** @type {(inputs: Nav_Sheet_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear conta, engadir barco ou rexistro de patrón`)
};

const en_nav_sheet_actions_desc = /** @type {(inputs: Nav_Sheet_Actions_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create account, add a boat or skipper registration`)
};

/**
* | output |
* | --- |
* | "Create account, add a boat or skipper registration" |
*
* @param {Nav_Sheet_Actions_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_sheet_actions_desc = /** @type {((inputs?: Nav_Sheet_Actions_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sheet_Actions_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_sheet_actions_desc(inputs)
	if (locale === "en") return en_nav_sheet_actions_desc(inputs)
	return es_nav_sheet_actions_desc(inputs)
});